const api = 'https://restcountries.com/v3.1/all';

export default api;
